/* eslint-disable @typescript-eslint/no-magic-numbers */
import { Injectable, inject } from '@angular/core';

import {
  MovableCardsContainerGroupTypeEnum,
  MovableCardsContainerSingleColumnGroup,
  MovableCardsContainerTwoColumnsGroup,
  SimpleDomRect,
} from '../movable-cards-container.view-model';
import { StateService } from './state.service';

@Injectable()
export class BoundingRectMapService<T extends string = string> {
  readonly #state = inject(StateService);

  public buildBoundingRectMapFromGroups(groups: (MovableCardsContainerSingleColumnGroup<T> | MovableCardsContainerTwoColumnsGroup<T>)[]): {
    rectMap: Record<string, SimpleDomRect>;
    totalHeight: number;
  } {
    const cardContainerRect = this.#state.cardContainerRect();
    const initialKeyBoundingRectMap = this.#state.initialKeyBoundingRectMap;
    const rowGapSize = this.#state.rowGapSize;
    const columnGapSize = this.#state.columnGapSize;
    let totalHeight = 0;

    const map: Record<string, SimpleDomRect> = {};

    groups.forEach((group, groupIdx) => {
      if (group.type === MovableCardsContainerGroupTypeEnum.SingleColumn) {
        group.cards.forEach((card, idx) => {
          const rect = initialKeyBoundingRectMap[card.key];
          const width = rect.width;
          const height = rect.height;

          map[card.key] = {
            width,
            height,
            left: cardContainerRect.left,
            top: cardContainerRect.top + totalHeight,
          };

          totalHeight += height;

          if (idx < group.cards.length - 1) {
            totalHeight += rowGapSize;
          }
        });
      } else {
        let leftHeight = 0;

        group.leftCards.forEach((card, idx) => {
          const rect = initialKeyBoundingRectMap[card.key];
          const width = rect.width;
          const height = rect.height;

          map[card.key] = {
            width,
            height,
            left: cardContainerRect.left,
            top: cardContainerRect.top + totalHeight + leftHeight,
          };

          leftHeight += height;

          if (idx < group.leftCards.length - 1) {
            leftHeight += rowGapSize;
          }
        });

        let rightHeight = 0;
        group.rightCards.forEach((card, idx) => {
          const rect = initialKeyBoundingRectMap[card.key];
          const width = rect.width;
          const height = rect.height;

          map[card.key] = {
            width,
            height,
            left: cardContainerRect.left + (cardContainerRect.width - columnGapSize) / 2 + columnGapSize,
            top: cardContainerRect.top + totalHeight + rightHeight,
          };

          rightHeight += height;

          if (idx < group.rightCards.length - 1) {
            rightHeight += rowGapSize;
          }
        });

        totalHeight += Math.max(leftHeight, rightHeight);
      }

      if (groupIdx < groups.length - 1) {
        totalHeight += rowGapSize;
      }
    });

    return {
      rectMap: map,
      totalHeight,
    };
  }
}
